export const ADD_INVITE_NOTIFICATION = 'add_invite_notification'
export const RESET_INVITE = 'reset_invite'
export const CLEAR_INVITE_NOTIFICATION = 'clear_invite_notification'
